import axios from '@/services/axiosConfig'
import ParamMaker from '@/utils/modules/ParamMaker'

const endPoint = {
	lookupMemberList: (instId, offset, length, keyword, groupsId) =>
		`/institute/${instId}/member/search?
			keyword=${keyword}&
			offset=${offset}&
			length=${length}`,
	lookupMember: (instId, id) => `/institute/${instId}/member?id=${id}`,
	updateMember: instId => `/institute/${instId}/member`,
	deleteMember: (instId, ids) =>
		`/institute/${instId}/member?${ParamMaker.setArrayString('ids', ids)}`,
	createInviteLink: instId => `/institute/${instId}/member/invite/link`,
	sendInviteEmail: instId => `/institute/${instId}/member/invite/email`,
}

const instituteMemberAPI = {
	lookupMemberList: (instId, offset, length, keyword, groupsId) =>
		axios.get(
			endPoint.lookupMemberList(instId, offset, length, keyword, groupsId)
		),
	lookupMember: (instId, id) => axios.get(endPoint.lookupMember(instId, id)),
	updateMember: (instId, body) =>
		axios.put(endPoint.updateMember(instId), body),
	deleteMember: (instId, ids) =>
		axios.delete(endPoint.deleteMember(instId, ids)),
	createInviteLink: (instId, data) => {
		return axios
			.post(endPoint.createInviteLink(instId), data)
			.then(result => {
				return axios
					.post('https://short.lab-manager.com/pro', {
						dest: result.data.link,
					})
					.then(shortResult => {
						result.data.link = shortResult.data.url
						return result
					})
			})
	},
	sendInviteEmail: (instId, data) => {
		return axios.post(endPoint.sendInviteEmail(instId), data)
	},
}

export default instituteMemberAPI
